/* dependencies to install in CLI --> must change directory into eventbadgescorereact project first
    - npm install react react-router-dom buffer
    - npm i --save @fortawesome/fontawesome-svg-core
    - npm install react-to-print

    # Free icons styles
    npm i --save @fortawesome/free-solid-svg-icons
    npm i --save @fortawesome/free-regular-svg-icons
    npm i --save @fortawesome/react-fontawesome@latest

    # Drag and drop
    npm install @hello-pangea/dnd

    # MultiSelect Dropdown 
    npm install multiselect-react-dropdown  

    # Drag and drop images
    npm install --save react-dropzone

    # cookies
    npm install js-cookie

    # select that supports pagination on menu scroll
    npm install react-select react-select-async-paginate

    # tabs component
    npm install react-tabs

     # grid component
    npm install react-grid

    # pdf generator/handler
    npm install react-to-pdf

    # excel generator/handler
    npm install exceljs

    # save files locally
    npm install file-saver
*/

import React, { useState } from 'react'
import { Routes, Route, useNavigate, useParams } from 'react-router-dom'

// pages
import Landing from './pages/Landing/Landing'
import Index from './pages/Index/Index'
import Home from './pages/Home/Home'
import ChangePassword from './pages/Account/ChangePassword/ChangePassword'
import ManageAccountSettings from './pages/Account/ManageAccountSettings/ManageAccountSettings'
import ForgotPassword from './pages/Home/ForgotPassword/ForgotPassword'
import ResetPassword from './pages/Home/ResetPassword/ResetPassword'
import EventRegSystemsList from './pages/Home/EventRegSystemsList/EventRegSystemsList'
import ClientCategoryList from './pages/Home/ClientCategoryList/ClientCategoryList'
import SiteFilterList from './pages/Home/SiteFilterList/SiteFilterList'
import ClientConfig from './pages/Home/ClientConfig/ClientConfig'
import ClientEventData from './pages/Home/ClientEventData/ClientEventData'
import ClientList from './pages/Home/ClientList/ClientList'
import EventLoad from './pages/Home/EventLoad/EventLoad'
import ClientLoad from './pages/Home/ClientLoad/ClientLoad'
import ViewGenerate from './pages/Home/ViewGenerate/ViewGenerate'
import EventSetting from './pages/Home/EventSetting/EventSetting'
import EventFilterListManager from './pages/Home/EventFilterListManager/EventFilterListManager'
import EventFilterList from './pages/Home/EventFilterList/EventFilterList'
import GuestEventFilterList from './pages/Home/GuestEventFilterList/GuestEventFilterList'
import WebHookList from './pages/Home/WebHookList/WebHookList'
import TemplateManager from './pages/Home/TemplateManager/TemplateManager'
import FlatTemplateSetup from './pages/Badging/FlatTemplateSetup/FlatTemplateSetup'
import CSHTMLConversionTemplateSetup from './pages/Badging/CSHTMLConversionTemplateSetup/CSHTMLConversionTemplateSetup'
import BadgeTemplateIndex from './pages/Badging/BadgeTemplateIndex/BadgeTemplateIndex'
import BadgeToERSPropertyMappingManager from './pages/Badging/BadgeToERSPropertyMappingManager/BadgeToERSPropertyMappingManager'
import BadgeToERSPropertyMapping from './pages/Badging/BadgeToERSPropertyMapping/BadgeToERSPropertyMapping'
import BadgeToERSPropertyGuestMapping from './pages/Badging/BadgeToERSPropertyGuestMapping/BadgeToERSPropertyGuestMapping'
import PrintPreview from './pages/Badging/PrintPreview/PrintPreview'
import EventBadgesManager from './pages/Home/EventBadgesManager/EventBadgesManager'
import EventBadgesTemplateManager from './pages/Home/EventBadgesTemplateManager/EventBadgesTemplateManager'
import MainBadgeTemplateStyling from './pages/Badging/MainBadgeTemplateStyling/MainBadgeTemplateStyling'
import GuestBadgeTemplateStyling from './pages/Badging/GuestBadgeTemplateStyling/GuestBadgeTemplateStyling'
import ExtraBadgeTemplateStyling from './pages/Badging/ExtraBadgeTemplateStyling/ExtraBadgeTemplateStyling'
import RegTypeMapping from './pages/Badging/RegTypeMapping/RegTypeMapping'
import ExtraBadgeManager from './pages/Badging/ExtraBadgeManager/ExtraBadgeManager'
import BadgeImageManager from './pages/Badging/BadgeImageManager/BadgeImageManager'
import BadgeScannerImageManager from './pages/Badging/BadgeScannerImageManager/BadgeScannerImageManager'
import KioskManager from './pages/Badging/KioskManager/KioskManager'
import BadgeTemplateFieldOrdering from './pages/Badging/BadgeTemplateFieldOrdering/BadgeTemplateFieldOrdering'
import GuestBadgeTemplateFieldOrdering from './pages/Badging/GuestBadgeTemplateFieldOrdering/GuestBadgeTemplateFieldOrdering'
import BadgeTemplateManager from './pages/Badging/BadgeTemplateManager/BadgeTemplateManager'
import GuestBadgeTemplateManager from './pages/Badging/GuestBadgeTemplateManager/GuestBadgeTemplateManager'
import RegistrantToGuestMapping from './pages/Badging/RegistrantToGuestMapping/RegistrantToGuestMapping'
import KioskSetup from './pages/Badging/KioskSetup/KioskSetup'
import KioskLandingPageSetup from './pages/Badging/KioskLandingPageSetup/KioskLandingPageSetup'
import KioskScannerPageSetup from './pages/Badging/KioskScannerPageSetup/KioskScannerPageSetup'
import KioskEditScreenLayout from './pages/Badging/KioskEditScreenLayout/KioskEditScreenLayout'
import StaticFieldManager from './pages/Badging/StaticFieldManager/StaticFieldManager'
import ExtraBadgeTemplateManager from './pages/Badging/ExtraBadgeTemplateManager/ExtraBadgeTemplateManager'
import ExtraBadgeTemplateFieldOrdering from './pages/Badging/ExtraBadgeTemplateFieldOrdering/ExtraBadgeTemplateFieldOrdering'
import ManageSiteAccounts from './pages/Home/ManageSiteAccounts/ManageSiteAccounts'
import ManageSiteAttachments from './pages/Home/ManageSiteAttachments/ManageSiteAttachments'
import KioskIndex from './pages/Kiosk/KioskIndex/KioskIndex'
import KioskEdit from './pages/Kiosk/KioskEdit/KioskEdit'
import KioskPrint from './pages/Kiosk/KioskPrint/KioskPrint'
import KioskScanner from './pages/Kiosk/KioskScanner/KioskScanner'
import KioskLanding from './pages/Kiosk/KioskLanding/KioskLanding'
import Logoff from './pages/Landing/Logoff'
import EventStatusManager from './pages/Home/EventStatusManager/EventStatusManager'
import EventSetupStatusManager from './pages/Home/StatusSubpages/EventSetupStatusManager'
import EventBadgesStatusManager from './pages/Home/StatusSubpages/EventBadgesStatusManager'
import ExtraBadgesStatusManager from './pages/Home/StatusSubpages/ExtraBadgesStatusManager'
import GuestBadgesStatusManager from './pages/Home/StatusSubpages/GuestBadgesStatusManager'
import KioskSetupStatusManager from './pages/Home/StatusSubpages/KioskSetupStatusManager'
import EventSpecificStatusPage from './pages/Home/StatusSubpages/EventSpecificStatusPage'
import AttendanceReport from './pages/Badging/AttendanceReport/AttendanceReport'
import SnapshotMonitor from './pages/Badging/SnapshotMonitor/SnapshotMonitor'
import AdminPrint from './pages/Badging/AdminPrint/AdminPrint'
import AdminPrintFlat from './pages/Badging/AdminPrintFlat/AdminPrintFlat'
import AdHocPrint from './pages/Badging/AdHocPrint/AdHocPrint'
import AdHocPrintFlat from './pages/Badging/AdHocPrintFlat/AdHocPrintFlat'
import KioskFull from './pages/Kiosk/KioskFull/KioskFull'
import KioskFullFlat from './pages/Kiosk/KioskFullFlat/KioskFullFlat'
import LeadCaptureList from './pages/LeadCapture/LeadCaptureList/LeadCaptureList'
import LeadCaptureConfig from './pages/LeadCapture/LeadCaptureConfig/LeadCaptureConfig'
import ExhibitorManager from './pages/LeadCapture/ExhibitorManager/ExhibitorManager'
import InvoiceManager from './pages/LeadCapture/InvoiceManager/InvoiceManager'
import GenerateInvoice from './pages/LeadCapture/GenerateInvoice/GenerateInvoice'
import ExhibitorList from './pages/LeadCapture/ExhibitorList/ExhibitorList'
import ExhibitorConfig from './pages/LeadCapture/ExhibitorConfig/ExhibitorConfig'
import LeadCaptureReports from './pages/LeadCapture/LeadCaptureReports/LeadCaptureReports'
import MobileAppManager from './pages/LeadCapture/MobileAppManager/MobileAppManager'
import QualifierManager from './pages/LeadCapture/QualifierManager/QualifierManager'
import LicenseManager from './pages/LeadCapture/LicenseManager/LicenseManager'
import ExhibitorLicenseManager from './pages/LeadCapture/ExhibitorLicenseManager/ExhibitorLicenseManager'
import LeadCaptureSetting from './pages/LeadCapture/LeadCaptureSetting/LeadCaptureSetting'
import ExhibitorLeads from './pages/LeadCapture/ExhibitorLeads/ExhibitorLeads'
import ExhibitorPasscodes from './pages/LeadCapture/ExhibitorPasscodes/ExhibitorPasscodes'
import LeadCaptureMonitor from './pages/LeadCapture/LeadCaptureMonitor/LeadCaptureMonitor'
// components
/*import Signup from './components/Signup/Signup'*/
import NavBar from './components/NavBar/NavBar'
import LoginForm from './components/Home/LoginForm/LoginForm'
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute'

// services
import *  as homeService from './services/homeService'

// Wrapper forces a full remount of EventSpecificStatusPage when the event in the URL changes
const KeyedEventSpecificStatusPage = (props) => {
    const { EventId } = useParams()
    return <EventSpecificStatusPage key={EventId ?? 'no-event'} {...props} />
}

const App = () => {
    const navigate = useNavigate()
    const [user, setUser] = useState(homeService.getUser())
    const [role, setRole] = useState([''])
    const [isNavbarExpanded, setIsNavbarExpanded] = useState(false)

    const handleLogout = () => {
        homeService.logout()
        setUser(null)
		setRole(null)
        navigate('/')
    }

    const handleSignupOrLogin = () => {
        setUser(homeService.getUser())
    }

    const [message, setMessage] = useState([''])

    const handleChange = e => {
        //console.log(e.target.value)
    }

    const updateMessage = msg => {
        setMessage(msg)
    }

    const toggleNavbar = () => {
        setIsNavbarExpanded((prev) => !prev)
    }

    return (
        <>
            <NavBar 
                user={user}
                handleLogout={handleLogout}
                isNavbarExpanded={isNavbarExpanded}
                setIsNavbarExpanded={setIsNavbarExpanded}
                toggleNavbar={toggleNavbar}
            />

            <div
                className={
                    isNavbarExpanded
                        ? `pageWithNavbarExpanded`
                        : `pageWithNavbarCollapsed`
                }
            >
            
            <Routes>
                <Route path="/" element={
                    <Landing
                        user={user}
                        handleSignupOrLogin={handleSignupOrLogin}
                        LoginForm={LoginForm}
                        handleChange={handleChange}
                        message={message}
                        setMessage={setMessage}
                        updateMessage={updateMessage}
                    />}
                />
                <Route
                    path="/logoff"
                    element={
                        <Logoff
                            user={user}
                        />
                    }
                />
                <Route
                    path="/home"
                    element={
                        <ProtectedRoute user={user}>
                            <Home
                                user={user}
                                handleChange={handleChange}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/index"
                    element={
                        <ProtectedRoute user={user}>
                            <Index
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/changepassword"
                    element={
                        <ProtectedRoute user={user}>
                            <ChangePassword
                                user={user}
                                updateMessage={updateMessage}
                                handleSignupOrLogin={handleSignupOrLogin}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/forgotpassword"
                    element={
                        <ForgotPassword />
                    }
                />
                <Route
                    path="/resetpassword"
                    element={
                        <ResetPassword />
                    }
                />
                <Route
                    path="/ManageAccountSettings"
                    element={
                        <ProtectedRoute user={user}>
                            <ManageAccountSettings
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/EventRegSystemsList"
                    element={
                        <ProtectedRoute user={user}>
                            <EventRegSystemsList
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/ClientCategoryList"
                    element={
                        <ProtectedRoute user={user}>
                            <ClientCategoryList
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/SiteFilterList"
                    element={
                        <ProtectedRoute user={user}>
                            <SiteFilterList
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                    />
                <Route
                    path="/ClientConfig"
                    element={
                        <ProtectedRoute user={user}>
                            <ClientConfig
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/ClientConfig/:ClientId"
                    element={
                        <ProtectedRoute user={user}>
                            <ClientConfig
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/ClientConfig/:ClientId/edit"
                    element={
                        <ProtectedRoute user={user}>
                            <ClientConfig
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
				<Route
                    path="/ClientEventData"
                    element={
                        <ProtectedRoute user={user}>
                            <ClientEventData
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/ClientEventData/:ClientId"
                    element={
                        <ProtectedRoute user={user}>
                            <ClientEventData
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/ClientList"
                    element={
                        <ProtectedRoute user={user}>
                            <ClientList
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/EventLoad"
                    element={
                        <ProtectedRoute user={user}>
                            <EventLoad
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/EventLoad/:EventId"
                    element={
                        <ProtectedRoute user={user}>
                            <EventLoad
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                    />
                    <Route
                        path="/ClientLoad"
                        element={
                            <ProtectedRoute user={user}>
                                <ClientLoad
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/ClientLoad/:ClientId"
                        element={
                            <ProtectedRoute user={user}>
                                <ClientLoad
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                <Route
                    path="/ViewGenerate"
                    element={
                        <ProtectedRoute user={user}>
                            <ViewGenerate
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                    />
                   
                <Route
                    path="/EventSetting"
                    element={
                        <ProtectedRoute user={user}>
                            <EventSetting
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/EventSetting/:EventId"
                    element={
                        <ProtectedRoute user={user}>
                            <EventSetting
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                    />
                    <Route
                        path="/TemplateManager"
                        element={
                            <ProtectedRoute user={user}>
                                <TemplateManager
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/FlatTemplateSetup"
                        element={
                            <ProtectedRoute user={user}>
                                <FlatTemplateSetup
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/CSHTMLConversionTemplateSetup"
                        element={
                            <ProtectedRoute user={user}>
                                <CSHTMLConversionTemplateSetup
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                 <Route
                    path="/EventSetting/WebHookList"
                    element={
                        <ProtectedRoute user={user}>
                            <WebHookList
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/EventSetting/WebHookList/:EventId"
                    element={
                        <ProtectedRoute user={user}>
                            <WebHookList
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                    />
                    <Route
                        path="/EventSetting/EventFilterListManager"
                        element={
                            <ProtectedRoute user={user}>
                                <EventFilterListManager
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                <Route
                    path="/EventSetting/EventFilterList"
                    element={
                        <ProtectedRoute user={user}>
                            <EventFilterList
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                    />
                    <Route
                        path="/EventSetting/GuestEventFilterList"
                        element={
                            <ProtectedRoute user={user}>
                                <GuestEventFilterList
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                <Route
                    path="/BadgeTemplateIndex"
                    element={
                        <ProtectedRoute user={user}>
                            <BadgeTemplateIndex
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                    />
                    <Route
                        path="/BadgeToERSPropertyMappingManager"
                        element={
                            <ProtectedRoute user={user}>
                                <BadgeToERSPropertyMappingManager
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                <Route
                    path="/BadgeToERSPropertyMapping"
                    element={
                        <ProtectedRoute user={user}>
                            <BadgeToERSPropertyMapping
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                    />
                    <Route
                        path="/BadgeToERSPropertyGuestMapping"
                        element={
                            <ProtectedRoute user={user}>
                                <BadgeToERSPropertyGuestMapping
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                <Route
                    path="/PrintPreview"
                    element={
                        <ProtectedRoute user={user}>
                            <PrintPreview
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/MainBadgeTemplateStyling"
                    element={
                        <ProtectedRoute user={user}>
                            <MainBadgeTemplateStyling
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                    />
                    <Route
                        path="/GuestBadgeTemplateStyling"
                        element={
                            <ProtectedRoute user={user}>
                                <GuestBadgeTemplateStyling
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                <Route
                    path="/ExtraBadgeTemplateStyling"
                    element={
                        <ProtectedRoute user={user}>
                            <ExtraBadgeTemplateStyling
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/EventBadgesManager"
                    element={
                        <ProtectedRoute user={user}>
                            <EventBadgesManager
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                    />
                    <Route
                        path="/EventBadgesTemplateManager"
                        element={
                            <ProtectedRoute user={user}>
                                <EventBadgesTemplateManager
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                <Route
                    path="/RegTypeMapping"
                    element={
                        <ProtectedRoute user={user}>
                            <RegTypeMapping
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/ExtraBadgeManager"
                    element={
                        <ProtectedRoute user={user}>
                            <ExtraBadgeManager
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/BadgeImageManager"
                    element={
                        <ProtectedRoute user={user}>
                            <BadgeImageManager
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/BadgeScannerImageManager"
                    element={
                        <ProtectedRoute user={user}>
                            <BadgeScannerImageManager
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/KioskManager"
                    element={
                        <ProtectedRoute user={user}>
                            <KioskManager
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                        path="/GuestBadgeTemplateFieldOrdering"
                    element={
                        <ProtectedRoute user={user}>
                            <GuestBadgeTemplateFieldOrdering
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                    />
                    <Route
                        path="/BadgeTemplateFieldOrdering"
                        element={
                            <ProtectedRoute user={user}>
                                <BadgeTemplateFieldOrdering
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                <Route
                    path="/KioskSetup"
                    element={
                        <ProtectedRoute user={user}>
                            <KioskSetup
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/KioskScannerPageSetup"
                    element={
                        <ProtectedRoute user={user}>
                            <KioskScannerPageSetup
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/KioskLandingPageSetup"
                    element={
                        <ProtectedRoute user={user}>
                            <KioskLandingPageSetup
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/BadgeTemplateManager"
                    element={
                        <ProtectedRoute user={user}>
                            <BadgeTemplateManager
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                    />
                    <Route
                        path="/GuestBadgeTemplateManager"
                        element={
                            <ProtectedRoute user={user}>
                                <GuestBadgeTemplateManager
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/RegistrantToGuestMapping"
                        element={
                            <ProtectedRoute user={user}>
                                <RegistrantToGuestMapping
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                <Route
                    path="/KioskEditScreenLayout"
                    element={
                        <ProtectedRoute user={user}>
                            <KioskEditScreenLayout
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/StaticFieldManager"
                    element={
                        <ProtectedRoute user={user}>
                            <StaticFieldManager
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/ExtraBadgeTemplateManager"
                    element={
                        <ProtectedRoute user={user}>
                            <ExtraBadgeTemplateManager
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/ExtraBadgeTemplateFieldOrdering"
                    element={
                        <ProtectedRoute user={user}>
                            <ExtraBadgeTemplateFieldOrdering
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/ManageSiteAccounts"
                    element={
                        <ProtectedRoute user={user}>
                            <ManageSiteAccounts
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                    />
                    <Route
                        path="/ManageSiteAttachments"
                        element={
                            <ProtectedRoute user={user}>
                                <ManageSiteAttachments
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                <Route
                        path="Kiosk/KioskFull"
                        element={
                            <ProtectedRoute user={user}>
                                <KioskFull
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="Kiosk/KioskFullFlat"
                        element={
                            <ProtectedRoute user={user}>
                                <KioskFullFlat
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                <Route
                    path="Kiosk/Index"
                    element={
                        <ProtectedRoute user={user}>
                            <KioskIndex
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="Kiosk/Edit"
                    element={
                        <ProtectedRoute user={user}>
                            <KioskEdit
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="Kiosk/Print"
                    element={
                        <ProtectedRoute user={user}>
                            <KioskPrint
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                    />
                <Route
                    path="Kiosk/Scanner"
                    element={
                        <ProtectedRoute user={user}>
                            <KioskScanner
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                    />
                    <Route
                        path="Kiosk/Landing"
                        element={
                            <ProtectedRoute user={user}>
                                <KioskLanding
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                <Route
                    path="/EventStatusManager"
                    element={
                        <ProtectedRoute user={user}>
                            <EventStatusManager
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/EventSetupStatusManager"
                    element={
                        <ProtectedRoute user={user}>
                            <EventSetupStatusManager
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/EventSetupStatusManager/:EventId"
                    element={
                        <ProtectedRoute user={user}>
                            <EventSetupStatusManager
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/EventBadgesStatusManager"
                    element={
                        <ProtectedRoute user={user}>
                            <EventBadgesStatusManager
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/EventBadgesStatusManager/:EventId"
                    element={
                        <ProtectedRoute user={user}>
                            <EventBadgesStatusManager
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/ExtraBadgesStatusManager"
                    element={
                        <ProtectedRoute user={user}>
                            <ExtraBadgesStatusManager
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/ExtraBadgesStatusManager/:EventId"
                    element={
                        <ProtectedRoute user={user}>
                            <ExtraBadgesStatusManager
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                    />
                    <Route
                        path="/GuestBadgesStatusManager"
                        element={
                            <ProtectedRoute user={user}>
                                <GuestBadgesStatusManager
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/GuestBadgesStatusManager/:EventId"
                        element={
                            <ProtectedRoute user={user}>
                                <GuestBadgesStatusManager
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                <Route
                    path="/EventSpecificStatusPage"
                    element={
                        <ProtectedRoute user={user}>
                            <KeyedEventSpecificStatusPage
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/EventSpecificStatusPage/:EventId"
                    element={
                        <ProtectedRoute user={user}>
                            <KeyedEventSpecificStatusPage
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/KioskSetupStatusManager"
                    element={
                        <ProtectedRoute user={user}>
                            <KioskSetupStatusManager
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/KioskSetupStatusManager/:EventId"
                    element={
                        <ProtectedRoute user={user}>
                            <KioskSetupStatusManager
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/AttendanceReport"
                    element={
                        <ProtectedRoute user={user}>
                            <AttendanceReport
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                    />
                    <Route
                        path="/SnapshotMonitor"
                        element={
                            <ProtectedRoute user={user}>
                                <SnapshotMonitor
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                <Route
                    path="/AdminPrint"
                    element={
                        <ProtectedRoute user={user}>
                            <AdminPrint
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                />
                    <Route
                        path="/AdminPrintFlat"
                        element={
                            <ProtectedRoute user={user}>
                                <AdminPrintFlat
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                <Route
                    path="/AdHocPrint"
                    element={
                        <ProtectedRoute user={user}>
                            <AdHocPrint
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                    />
                    <Route
                        path="/AdHocPrintFlat"
                        element={
                            <ProtectedRoute user={user}>
                                <AdHocPrintFlat
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="LeadCaptureList"
                        element={
                            <ProtectedRoute user={user}>
                                <LeadCaptureList
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="LeadCaptureConfig"
                        element={
                            <ProtectedRoute user={user}>
                                <LeadCaptureConfig
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/LeadCaptureConfig/:leadCaptureId"
                        element={
                            <ProtectedRoute user={user}>
                                <LeadCaptureConfig
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/LeadCaptureConfig/:leadCaptureId/edit"
                        element={
                            <ProtectedRoute user={user}>
                                <LeadCaptureConfig
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="ExhibitorList"
                        element={
                            <ProtectedRoute user={user}>
                                <ExhibitorList
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="InvoiceManager"
                        element={
                            <ProtectedRoute user={user}>
                                <InvoiceManager
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="GenerateInvoice"
                        element={
                            <ProtectedRoute user={user}>
                                <GenerateInvoice
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="ExhibitorManager"
                        element={
                            <ProtectedRoute user={user}>
                                <ExhibitorManager
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="ExhibitorConfig"
                        element={
                            <ProtectedRoute user={user}>
                                <ExhibitorConfig
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/ExhibitorConfig/:exhibitorId"
                        element={
                            <ProtectedRoute user={user}>
                                <ExhibitorConfig
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/ExhibitorConfig/:exhibitorId/edit"
                        element={
                            <ProtectedRoute user={user}>
                                <ExhibitorConfig
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="LeadCaptureReports"
                        element={
                            <ProtectedRoute user={user}>
                                <LeadCaptureReports
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="MobileAppManager"
                        element={
                            <ProtectedRoute user={user}>
                                <MobileAppManager
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="QualifierManager"
                        element={
                            <ProtectedRoute user={user}>
                                <QualifierManager
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="LicenseManager"
                        element={
                            <ProtectedRoute user={user}>
                                <LicenseManager
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="ExhibitorLicenseManager"
                        element={
                            <ProtectedRoute user={user}>
                                <ExhibitorLicenseManager
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/ExhibitorLeads"
                        element={
                            <ProtectedRoute user={user}>
                                <ExhibitorLeads
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/ExhibitorPasscodes"
                        element={
                            <ProtectedRoute user={user}>
                                <ExhibitorPasscodes
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/LeadCaptureMonitor"
                        element={
                            <ProtectedRoute user={user}>
                                <LeadCaptureMonitor
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/LeadCaptureSetting"
                        element={
                            <ProtectedRoute user={user}>
                                <LeadCaptureSetting
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/LeadCaptureSetting/:LeadCaptureId"
                        element={
                            <ProtectedRoute user={user}>
                                <LeadCaptureSetting
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />

                    
                {/*<Route*/}
                {/*    path="/signup"*/}
                {/*    element={<Signup handleSignupOrLogin={handleSignupOrLogin} />}*/}
                {/*/>*/}

                {/*<Route path="/clients"*/}

                {/*/>*/}
            </Routes>
            </div>
            </>
    )
}

export default App
